export function MascotPortrait({ size = "w-14 h-14", className = "" }) {
  return <img src="/brand/mwp_coin.webp" alt="King Wolf, your guide" className={`${size} shrink-0 rounded-full drop-shadow-[0_0_12px_rgba(252,211,77,0.35)] mascot-bob ${className}`} />;
}

export function MascotTip({ testid, children, className = "" }) {
  return (
    <div data-testid={testid} className={`flex items-center gap-3 rise ${className}`}>
      <MascotPortrait size="w-12 h-12" />
      <p className="relative text-sm text-amber-50/90 bg-slate-900/80 border border-amber-400/30 rounded-2xl rounded-bl-sm px-4 py-2.5 max-w-md">{children}</p>
    </div>
  );
}

const LINES = {
  win: ["That's how a king hunts!", "Clean work. The Shadowfang felt that one.", "Another one down. Keep that tail high!", "Ha! They never stood a chance.", "The pack sings your name tonight."],
  boss: ["A whole region freed! Crowns off to you... well, not mine.", "The boss is down! The forest breathes again.", "Legendary. I couldn't have done it better myself. Almost."],
  streak: ["You're on fire! Don't let that streak cool down.", "Win after win. Now that's royal form."],
  common: ["Every little bit fills the den.", "Not bad! Small treasures add up."],
  rare: ["Ooh, a rare one! Shiny.", "Now we're talking. Good find!"],
  epic: ["EPIC! Even my crown is jealous.", "What a pull! Treasure fit for a king."],
  legendary: ["LEGENDARY! Bow to the luckiest wolf in the forest!", "I've waited my whole reign to see one of these!"],
  quest: ["Quest done! That's the spirit.", "Ticked off! The day is yours.", "Another quest down. Proud of you, pup."],
};

export const cheer = (kind) => { const l = LINES[kind] || LINES.win; return l[Math.floor(Math.random() * l.length)]; };
